<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Please log in to your myEmil Frey account"
        key="customerPortal.kc.login-now"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
  </div>
  <div class="login-form w-full lg:w-1/2 py-6 flex-1">
    <form
      class="flex flex-col gap-3 revolution-form"
      #requestBusinessInviteForm
      method="POST"
      [formGroup]="form"
      [action]="viewData?.registrationAction"
      (ngSubmit)="register()"
    >
      <mat-form-field class="email">
        <mat-label>
          <T
            str="Business email"
            key="customerPortal.kc.request-business-invite.email"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="email"
          name="email"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="form.controls.email.touched && form.controls.email.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.email.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.email,
              'customerPortal.kc.request-business-invite.email.error.',
              {
                errKey: {
                  pattern: 'enter-valid-email',
                  email: 'enter-valid-email',
                  maxlength: 'maximum-length-exceeded'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="company-name">
        <mat-label>
          <T
            str="Company name"
            key="customerPortal.kc.request-business-invite.name"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="domain"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="companyName"
          name="companyName"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="
            form.controls.companyName.touched &&
            form.controls.companyName.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.companyName.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.companyName,
              'customerPortal.kc.request-business-invite.companyName.error.'
            )
          }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="zip">
        <mat-label>
          {{ 'postcode' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="offer"></mat-icon>
        <input
          class="input"
          type="number"
          matInput
          required
          formControlName="zip"
          name="zip"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="form.controls.zip.touched && form.controls.zip.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error
          *ngIf="
            form.get('zip').errors &&
            !form.get('zip').errors.hasOwnProperty('pattern')
          "
        >
          {{
            transifexService.getErrorTranslation(
              form.controls.zip,
              'customerPortal.kc.request-business-invite.zip.error.',
              {
                num: remoteConfigService.get(
                  'regEx.addressRegEx.zip.maxLength'
                ),
                errKey: {
                  minlength: 'required-length-characters',
                  maxlength: 'required-length-characters',
                  pattern: 'only-numbers-allowed'
                }
              }
            )
          }}
        </mat-error>
        <mat-error
          *ngIf="
            form.get('zip').errors &&
            form.get('zip').errors.hasOwnProperty('pattern')
          "
        >
          {{ 'invalid-number' | sharedTranslate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="city">
        <mat-label>
          {{ 'city' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="location_city"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="city"
          name="city"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="form.controls.city.touched && form.controls.city.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.city.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.city,
              'customerPortal.kc.request-business-invite.city.error.',
              {
                num: remoteConfigService.get(
                  'regEx.addressRegEx.city.maxLength'
                ),
                errKey: {
                  maxlength: 'max-length-characters',
                  pattern: 'only-numbers-letters-allowed'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="vehicles">
        <mat-label>
          <T
            str="Number of vehicles"
            key="customerPortal.kc.request-business-invite.vehicles"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="vehicle"></mat-icon>
        <input
          class="input"
          type="number"
          matInput
          required
          formControlName="numberOfVehicles"
          name="numberOfVehicles"
        />
        <mat-icon
          *ngIf="
            form.controls.numberOfVehicles.touched &&
            form.controls.numberOfVehicles.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.numberOfVehicles.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.numberOfVehicles,
              'customerPortal.kc.request-business-invite.vehicles.error.'
            )
          }}
        </mat-error>
      </mat-form-field>

      <div>
        <button
          mat-button
          mat-flat-button
          color="secondary"
          class="w-full py-2 revolution button-spinner"
          [disabled]="!form.valid || submitting"
          type="submit"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting"
          >
          </customer-portal-ef-spinner>
          {{ 'next' | sharedTranslate }}
        </button>
      </div>
    </form>
  </div>
</div>
